import '../styles/Cart.css';
import '../styles/Disclaimer.css';

export default function Disclaimer() {
    return <div className="cart-page">
            <div className="cart-title-section">
                <header className="container">
                    <h2>Disclaimer</h2>
                </header>
            </div>
            
            <div className="disclaimer-main items-center flex flex-col justify-center">
                <div className="disclaimer">
                    <div className="svg-container">
                        <svg width="50" height="50" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M11 19C15.4183 19 19 15.4183 19 11C19 6.58172 15.4183 3 11 3C6.58172 3 3 6.58172 3 11C3 15.4183 6.58172 19 11 19Z" stroke="#053C26" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                            <path d="M21 21L16.65 16.65" stroke="#053C26" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </div>
                    <p></p>
            <p>ContractWell is not a law firm and does not offer legal services or legal advice. The resources provided on this website — including templates, guides and cheat sheet are intended for general informational purposes only and should not be considered a substitute for professional legal counsel.
Purchasing, downloading, or using any material from ContractWell does not establish an attorney-client or solicitor-client relationship between you and ContractWell or any of its contributors. As each business and legal context is different, we recommend consulting a qualified lawyer in your jurisdiction if you require personalized legal advice for specific issues.
Please refer to our complete Disclaimer for more information.</p>
                    <h2>Disclaimer</h2>
                </div>
            </div>
            
            <div className="cart-footer">
            </div>
        </div>;
}